<template>
<div>
<b-card header-tag="header" footer-tag="footer" class="mt-8">
    <template v-slot:header>
        <b-row>                         
            <b-col cols="12" md="6">
            <p class="mb-0" style="font-size: 21px">Listado de venta Rápida activas.</p>
                </b-col>
            <b-col cols="12" md="6">
                <div class="text-right">
                    <b-button variant="info" class="text-white" @click="newSale()">Nueva venta</b-button>
                </div>
            </b-col>
        </b-row>
    </template>
    <template>
        <b-card-text>
    
            <b-card no-body>
            <b-tabs card>
                <b-tab v-for="(tabObject, index) in ventasObject" :key="index" :title="'Venta ' + (index + 1)" @click.prevent="updateObjectTotalPrice(tabObject.id)">
                    <b-row>
                        <b-col cols="12" md="4">
                            Tipo venta <b-form-select v-model="tabObject.tipo_venta" :options="options" @change="updatetipoventa(tabObject.id, tabObject.tipo_venta)"></b-form-select>
                        </b-col>
                        
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="4" v-if="tabObject.tipo_venta === '3'">
                            Tipo documento:
                            <b-form-group>
                                <b-form-select
                                    v-model="tabObject.tipo_documento"
                                    :options="tipo_documento_list"
                                    id="tipo_documento"
                                    value-field="tipo"
                                    text-field="label"
                                    >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            Nit: <b-form-input type="text" v-model="tabObject.nit" @keydown.enter.prevent="searchCliente(tabObject.id)" :disabled="tabObject.disable == 1"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            Nombre y Apellido: <b-form-input type="text" v-model="tabObject.nombre"  :disabled="tabObject.disable == 1"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            Telefono: <b-form-input type="number" v-model="tabObject.telefono" value="10" :disabled="tabObject.disable == 1"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row v-if="tabObject.tipo_venta === '3'">
                        <b-col cols="12" md="4">
                            <label for="departamento">Departamento</label>
                                <b-form-group>
                                    
                                <b-form-select
                                v-model="tabObject.departamento_id"
                                :options="departamentos_list"
                                id="departamento"
                                value-field="id"
                                text-field="nombre"
                                @change="getCiudadesList(tabObject.id, tabObject.departamento_id)"
                                >
                                <template #first>
                                    <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="ciudad">Ciudad</label>
                            <b-form-group>
                                    
                                <b-form-select
                                v-model="tabObject.ciudad_id"
                                :options="tabObject.ciudades_list"
                                id="ciudad"
                                value-field="id"
                                text-field="nombre"
                                >
                                <template #first>
                                    <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="12">
                            Dirección: <b-form-input type="text" v-model="tabObject.direccion"></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row class="pb-5">
                        <b-col cols="12" md="2">
                            Cantidad
                            <b-form-input type="number" v-model="tabObject.search_cantidad" ></b-form-input> 
                        </b-col>
                        <b-col cols="12" md="3">
                            Código de barra
                            <b-form-input :ref="'search_codigo_' + tabObject.id" :id="'search_codigo_' +tabObject.id" type="text" @keydown.enter.prevent="searchItem(tabObject.id, 1)"  v-model="tabObject.search_codigo_barras" ></b-form-input> 
                        </b-col>
                        <b-col cols="12" md="3">
                            Código item
                            <b-form-input type="text" @keydown.enter.prevent="searchItem(tabObject.id, 2)" v-model="tabObject.search_codigo_item" ></b-form-input> 
                        </b-col>
                        <b-col cols="12" md="4">
                            Descripción
                              <vue-bootstrap-typeahead
                                    v-model="tabObject.search_descripcion"
                                    :data="tabObject.item_search_autocomplete"
                                    :serializer="serializarValor"
                                    @hit="onArticuloSeleccionado"
                                    @input="instaSearch(tabObject.id, tabObject.search_descripcion)"
                                    :ref="'autocomplete' + tabObject.id"
                                    :id="'search_nombre_'+tabObject.id"
                                />
                        </b-col>
                        
                    </b-row>
                    <template>

                        <b-card-text>
                            <b-table striped hover
                                :fields='fields'
                                :items="tabObject.items"
                            >
                                <template v-slot:cell(codigo)="data">
                                    {{ data.item.codigo }}
                                </template>

                                <template v-slot:cell(precio_final_rent)="data">
                                $ {{ numberFormat(data.item.precio_final_rent) }}
                                </template>

                                <template #cell(subtotal)="data" >
                                $ {{ numberFormat(data.item.subtotal)}} 
                                </template>
                                <template v-slot:cell(actions)="data">
                                    <b-button variant="danger" v-b-tooltip.hover title="Eliminar" class="text-white" 
                                    @click="deleteItem(tabObject.id, data.item.codigo, data.item.descripcion, data.index)"
                                    >
                                        <b-icon icon="trash"></b-icon>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-card-text>
                    </template>
                    
                    <b-row class="pb-5">
                        <b-col cols="12" md="4">
                            <strong> Total a Pagar:</strong>
                            <b-input-group>
                                
                                <template #prepend>
                                    <b-input-group-text >$</b-input-group-text>
                                </template>
                                <b-form-input type="text" disabled :value="numberFormat(tabObject.monto_total)"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group  v-slot="{ ariaDescribedby }">
                                <strong class="mb-2"> Tipo de pago:</strong>
                                <b-form-radio v-model="tabObject.metodo_pago" :aria-describedby="ariaDescribedby" name="tipo-pago" value="1">Efectivo</b-form-radio>
                                <b-form-radio v-model="tabObject.metodo_pago" :aria-describedby="ariaDescribedby" name="tipo-pago" value="2">Tarjeta</b-form-radio>
                                <b-form-radio v-model="tabObject.metodo_pago" :aria-describedby="ariaDescribedby" name="tipo-pago" value="3">Crédito</b-form-radio>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4" v-if="tabObject.metodo_pago == 1">
                            <strong> Pago:</strong>
                            <b-input-group>
                                
                                <template #prepend>
                                    <b-input-group-text >$</b-input-group-text>
                                </template>
                                <b-form-input type="text" @keydown.enter.prevent="moverSubmit(tabObject.id)" v-model="tabObject.total_efectivo" placeholder="0" @blur="updateCambio(tabObject.id, tabObject.total_efectivo)" ></b-form-input>
                            </b-input-group>
                            <strong> Cambio:</strong>
                            <b-input-group>
                                
                                <template #prepend>
                                    <b-input-group-text >$</b-input-group-text>
                                </template>
                                <b-form-input type="text" disabled :value="numberFormat(tabObject.cambio_efectivo)"></b-form-input>
                            </b-input-group>
                        </b-col>

                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-button variant="danger" class="text-white" @click="deleteventa(tabObject.id)">Cancelar venta</b-button>
                        </b-col>
                        <b-col cols="12" md="6" class="text-right">
                            <b-button variant="success" :id="'procesar_venta_'+tabObject.id" class="text-white" @click="validateProcessventa(tabObject.id)">Procesar venta</b-button>
                        </b-col>
                    </b-row>
                </b-tab>
        
            </b-tabs>
            </b-card>
        

           
        </b-card-text>
            
    </template>
    <template v-slot:footer>
        <b-button id="volver" variant="danger" 
        class="text-white" 
        :to="{name: 'ListadoVentas'}">
            Volver Listado
        </b-button>
    </template>
</b-card>
    <template>
        <b-modal
        v-model="modalFactura"
        title="¿Imprimir Factura?"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <div class="text-center my-3"><b>¿Desea imprimir la factura?</b></div>
        <template v-slot:modal-footer>
            <b-row>
                <b-col cols="6">
                    <b-button variant="success" block :to="{name: 'printVenta', params:{ id: factura_id}}" target="_blank">
                        Imprimir
                    </b-button>
                </b-col>
                <b-col cols="6">
                    <b-button variant="danger" block
                        @click.prevent="closePrintFacturaModal()">
                        Cerrar
                    </b-button>
                </b-col>
            </b-row>
        </template>
        </b-modal>
    </template>

         

</div>
</template>
<script>

import { mapMutations, mapState} from 'vuex'
export default {
    computed: {
        ...mapState('auth', ['user']),
    },
    data(){
        return{
            modalFactura: false,
            factura_id: '',
            datos: {},
            ventasObject: [],
            fields: [
                { key: 'codigo_barras', label: 'Código de Barras', sortable: true},
                { key: 'codigo', label: 'Código', sortable: true},
                { key: 'descripcion', label: 'Descripción Artículo', sortable: true},
                { key: 'cantidad', label: 'Cantidad', sortable: true},
                { key: 'precio_final_rent', label: 'Precio', sortable: true},
                { key: 'subtotal', label: 'Total' },
                { key: 'actions', label: 'Acciones'},
            ],
            options: [
                { value: null, text: 'Por favor Seleccione una opcion', disabled: true},
                { value: '1', text: 'Usar mi Código' },
                { value: '2', text: 'Usar Cliente Ventas Contado' },
                { value: '3', text: 'Usar Otro Cliente'}
            ],
            openModalProcesarventa: false,
            departamentos_list: [],
            ciudades_list: [],
            tipo_documento_list: [],
        }
    },
    created(){
        this.getLocalventas();
        this.getDepartamentosList();
        this.getClientTypeDocumentList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getLocalventas(){
            this.ventasObject = JSON.parse(localStorage.getItem('ventasObject'));
            
            if(this.ventasObject == null){
                this.createDefaultSale();
            }else{

                this.updateObjectTotalPrice(this.ventasObject[0].id);
            }
        },
        createDefaultSale(){
            let random_id = this.randomString()
            let sale = [
                {
                    id: random_id,
                    tipo_venta: null,
                    nombre: '',
                    nit: '',
                    tipo_documento: 1,
                    telefono: '',
                    disable: 1,
                    total_efectivo: null,
                    cambio_efectivo: 0,
                    monto_total: 0,
                    search_codigo_barras: '',
                    search_codigo_item: '',
                    search_descripcion: '',
                    search_cantidad: 1,
                    item_search_autocomplete: [],
                    ciudades_list: [],
                    departamento_id: '',
                    ciudad_id: '',
                    direccion: '',
                    items:[]
                }
            ]

            this.ventasObject = sale;
            localStorage.setItem('ventasObject', JSON.stringify(sale));

        },

        updatetipoventa(objectId, newType){
            
            if(this.ventasObject != null){

                for (let i in this.ventasObject)
                {
                    if(this.ventasObject[i].id == objectId)
                    {
                        this.ventasObject[i].tipo_venta = newType;
                        if(newType == 1){
                            this.ventasObject[i].nit      = this.user.documento;
                            this.ventasObject[i].nombre   = this.user.nombre;
                            this.ventasObject[i].telefono = this.user.telefono;
                            this.ventasObject[i].disable  = 1;

                        }else if(newType == 2){
                            this.ventasObject[i].nit      = 'C1';
                            this.ventasObject[i].nombre   = 'Ventas Contado';
                            this.ventasObject[i].telefono = null;
                            this.ventasObject[i].disable  = 1;
                        }else if(newType == 3){
                            this.ventasObject[i].nit      = '';
                            this.ventasObject[i].nombre   = '';
                            this.ventasObject[i].telefono = '';
                            this.ventasObject[i].disable  = 0;
                        }
                        break;
                    }
                }

                let objName = 'search_codigo_' + objectId;
                
                this.$refs[objName][0].focus();
            }


            localStorage.setItem('ventasObject', JSON.stringify(this.ventasObject));
        },
        deleteventa(id){
            this.$swal({
                title: "¿Desea cancelar la venta?",
                text: "Una vez cancelada, no podra recuperar el listado de items registrados",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#008F39',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, cancelar venta.',
                cancelButtonText: 'Cancelar'
                })
                .then((result) => {
                if (result.isConfirmed) {
                    let deleteSale = this.ventasObject.map(function(item) {return item.id}).indexOf(id);

                    this.ventasObject.splice(deleteSale, 1);

                    if(this.ventasObject.length > 0){
                        localStorage.setItem('ventasObject', JSON.stringify(this.ventasObject));
                    }else{
                        localStorage.removeItem('ventasObject');
                        this.createDefaultSale();
                    }
                    this.$swal({
                    
                    position: 'top-end',
                    icon: 'success',
                    title: 'venta eliminada correctamente',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer)
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                    }
                    });
                }
                });

        },
        deleteItem(id, itemcodigo, itemDescription, itemIndex){

            this.$swal({
                title: "¿Desea eliminar el siguiente artículo?",
                text: itemDescription,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#008F39',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, cancelar venta.',
                cancelButtonText: 'Cancelar'
                })
                .then((result) => {
                if (result.isConfirmed) {

                    result = this.ventasObject.find(o => o.id === id).items;

                    result.splice(itemIndex, 1);

                    if(this.ventasObject.length > 0){
                        localStorage.setItem('ventasObject', JSON.stringify(this.ventasObject));
                    }else{
                        localStorage.removeItem('ventasObject');
                        this.createDefaultSale();
                    }
                    this.$swal({
                    
                        position: 'top-end',
                        icon: 'success',
                        title: 'Artículo eliminado correctamente',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                    this.updateObjectTotalPrice(id);
                }
                });
        },
        newSale(){

            let idGenerado = this.randomString();

            let existeId = this.ventasObject.find(o => o.id === idGenerado);
            if(existeId == null){
                
                
                let sale = 
                    {
                        id: idGenerado,
                        tipo_venta: null,
                        nombre: '',
                        nit: '',
                        telefono: '',
                        tipo_documento: 1,
                        disable: 1,
                        total_efectivo: null,
                        cambio_efectivo: 0,
                        monto_total: 0,
                        search_codigo_barras: '',
                        search_codigo_item: '',
                        search_descripcion: '',
                        search_cantidad: 1,
                        item_search_autocomplete: [],
                        ciudades_list: [],
                        departamento_id: '',
                        ciudad_id: '',
                        direccion: '',
                        items:[]
                    };


                this.ventasObject.push(sale);
                localStorage.setItem('ventasObject', JSON.stringify(this.ventasObject));

            }
        },

        randomString(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
    
        async updateObjectTotalPrice(objectId){
            let result = this.ventasObject.find(o => o.id === objectId);
            
            /*
            let items = result.items;

            for (let i in items)
            {
                console.log(items[i].precio);
                /*
                if(this.ventasObject[i].id == id)
                {
                    this.ventasObject[i].tipo_venta = newType;
                    break;
                }
                
            }
            */

            this.pageOptions = { 
                items:   result.items
            }
            this.setLoading(true)
            await this.$conectar.post('punto-venta/get-total-price-venta', this.pageOptions)
            .then(response =>{
                if(response.data.error == false){
                    this.ventasObject.find(o => o.id === objectId).items = [];
                    this.ventasObject.find(o => o.id === objectId).items = response.data.ventaItems;
                    this.ventasObject.find(o => o.id === objectId).monto_total = response.data.ventaObject.monto_total;

                    localStorage.setItem('ventasObject', JSON.stringify(this.ventasObject));

                    //document.getElementById('search_codigo_' +objectId).focus();
                }
            })
            .catch(e => {
                console.log(e.response);
            })

            this.setLoading(false)
        },
        updateCambio(objectId, total_efectivo){
            let object = this.ventasObject.find(o => o.id === objectId);
            if(!isNaN(total_efectivo)){
                if(total_efectivo){
                    object.cambio_efectivo = total_efectivo - object.monto_total;
                    object.total_efectivo = this.numberFormat(total_efectivo);
                }else{
                    object.cambio_efectivo = 0;
                }
            }else{
                object.cambio_efectivo = 0;
                object.total_efectivo = 0;
            }
        },
        async searchItem(objectId, typeSearch){
            if(typeSearch == 1){
                this.searchOptions = { 
                    search:   this.ventasObject.find(o => o.id === objectId).search_codigo_barras,
                    typeSearch: typeSearch
                }
            }else if (typeSearch == 2){
                this.searchOptions = { 
                    search:   this.ventasObject.find(o => o.id === objectId).search_codigo_item,
                    typeSearch: typeSearch
                }
            }else if (typeSearch == 3){
                this.searchOptions = { 
                    search:   this.ventasObject.find(o => o.id === objectId).search_descripcion,
                    typeSearch: typeSearch
                }
            }
            this.setLoading(true)
            await this.$conectar.post('punto-venta/search-item-venta', this.searchOptions)
            .then(response =>{
                if(response.data.error == false){
                        
                    let itemDetail = response.data.items; 
                    if(itemDetail.empresa_id == 0){
                        let item = 
                            {
                                codigo_barras: itemDetail.codigo_barras,
                                codigo: itemDetail.codigo,
                                precio: itemDetail.precio_final_con_imp,
                                precio_cargado: '0',
                                item_propio: '0',
                                cantidad: this.ventasObject.find(o => o.id === objectId).search_cantidad,
                                descripcion: itemDetail.nombre
                            }

                            this.ventasObject.find(o => o.id === objectId).items.push(item);
                    }else{
                        let item = 
                            {
                                codigo_barras: itemDetail.codigo_barras,
                                codigo: itemDetail.codigo,
                                precio: itemDetail.precio,
                                precio_cargado: '0',
                                item_propio: '1',
                                cantidad: this.ventasObject.find(o => o.id === objectId).search_cantidad,
                                descripcion: itemDetail.nombre
                            }

                            this.ventasObject.find(o => o.id === objectId).items.push(item);
                    }
                    this.updateObjectTotalPrice(objectId);
                        
                }else{
                    this.setLoading(false)
                    this.$swal({
                    showConfirmButton: true,
                    title: "Ateción.",
                    text: "No existe el articulo ingresado.",
                    icon: "warning",
                    confirmButtonColor: '#008F39',
                    });
                }
                this.ventasObject.find(o => o.id === objectId).search_codigo_barras = '';
                this.ventasObject.find(o => o.id === objectId).search_codigo_item = '';
                this.ventasObject.find(o => o.id === objectId).search_descripcion = '';
                this.ventasObject.find(o => o.id === objectId).search_cantidad = 1;
            })
            .catch(e => {
                console.log(e.response);
                this.setLoading(false)
            })

            
            
        },
        async searchCliente(objectId){
            let object = this.ventasObject.find(o => o.id === objectId);
            if(object.nit){
                this.searchOptions = { 
                    tipo_documento:   object.tipo_documento,
                    documento: object.nit
                }
                this.setLoading(true)
                await this.$conectar.post('punto-venta/search-cliente', this.searchOptions)
                .then(response =>{
                    if(response.data.error == false){
                        let dataCliente = response.data.cliente
                        object.nombre = dataCliente.cliente;
                        object.telefono = dataCliente.telefono;
                        object.departamento_id = dataCliente.departamento_id;
                        object.direccion = dataCliente.direccion;
                        this.getCiudadesList(objectId, dataCliente.departamento_id);

                        object.ciudad_id = dataCliente.ciudad_id;
                    }

                })
                .catch(e => {
                    console.log(e.response);
                    this.setLoading(false)
                })
                this.setLoading(false)
            }
            
        },
        async getClientTypeDocumentList() {
            this.setLoading(true)
            await this.$conectar.post('user/get-user-permissions-list')
            .then(response =>{
                this.tipo_documento_list = response.data.tipo_documento;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentos_list = response.data.departamentosList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList(objectId, departamentoId) {
            if(departamentoId){
                this.ventasObject.find(o => o.id === objectId).ciudad_id = '';
                this.departamentoSelected = { 
                    departamento_id: departamentoId, 
                }
                this.setLoading(true)
                await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
                .then(response =>{
                    this.ventasObject.find(o => o.id === objectId).ciudades_list = response.data.ciudadesList;
                })
                .catch(e => {
                    console.log(e.response);
                })
                this.setLoading(false)
            }else{
                this.ventasObject.find(o => o.id === objectId).ciudades_list = [];
            }
        },

        validateProcessventa(objectId){
            
            let venta = this.ventasObject.find(o => o.id === objectId);
            let validaFormError = false;
            let errores = '';
            if(venta.tipo_venta == null){
                validaFormError = true;
                errores = errores + '<li> Debe seleccionar el tipo de venta </li> <br>';
            }
            if(venta.tipo_venta == 3){
                if(venta.ciudad_id == '' || venta.departamento_id == ''){
                    validaFormError = true;
                    errores = errores + '<li> Debe seleccionar el departamento y ciudad </li> <br>';
                }
                 if(venta.nit == '' || venta.nombre == '' || venta.telefono == '' || venta.direccion == ''){
                    validaFormError = true;
                    errores = errores + '<li> Debe ingresar los datos del cliente. </li> <br>';
                }
            }
            if(venta.metodo_pago == null){
                validaFormError = true;
                errores = errores + '<li> Debe seleccionar el metodo de pago </li> <br>';
            }
            if(venta.items.length == 0){
                validaFormError = true;
                errores = errores + '<li> Debe agregar al menos un artículo para poder procesar la venta </li> <br>';
            }
            if(validaFormError){
                this.$swal({
                    showConfirmButton: true,
                    title: "Atención debe corregir los siguientes errores.",
                    html: errores,
                    icon: "warning",
                    confirmButtonColor: '#17a2b8',
                });
            }else{
                this.$swal({
                    showConfirmButton: true,
                    showCancelButton: true,
                    title: "Confirmar Venta.",
                    html: '¿Esta seguro que desea procesar la compra? <br> Una vez realizada no podra realizar modificaciónes.',
                    icon: "warning",
                    confirmButtonColor: '#008F39',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, procesar.',
                    cancelButtonText: 'Cancelar'
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.processventa(objectId);
                    }
                });
            }

        },
        async processventa(objectId){
            
            let venta = this.ventasObject.find(o => o.id === objectId);
            this.setLoading(true)
            let ventaObject = { 
                items          : venta.items,
                tipo_venta     : venta.tipo_venta,
                metodo_pago    : venta.metodo_pago,
                monto_total    : venta.monto_total,
                cambio_efectivo: venta.cambio_efectivo,
                total_efectivo : venta.total_efectivo,
                nit            : venta.nit,
                nombre         : venta.nombre,
                telefono       : venta.telefono,
                departamento_id: venta.departamento_id,
                ciudad_id      : venta.ciudad_id,
                direccion      : venta.direccion
            }
            this.setLoading(true)
            await this.$conectar.post('punto-venta/store-venta', ventaObject)
            .then(response =>{
                if(response.data.error == false){
                    this.modalFactura = true;
                    this.factura_id = response.data.id_impresion;

                    let deleteSale = this.ventasObject.map(function(item) {return item.id}).indexOf(objectId);

                    this.ventasObject.splice(deleteSale, 1);

                    if(this.ventasObject.length > 0){
                        localStorage.setItem('ventasObject', JSON.stringify(this.ventasObject));
                    }else{
                        localStorage.removeItem('ventasObject');
                        this.createDefaultSale();
                    }

                    
                    
                }else{
                    this.$swal({
                    showConfirmButton: true,
                    title: "Atención.",
                    html: "hubo un error al intentar grabar el pedido.",
                    icon: "warning",
                    confirmButtonColor: '#17a2b8',
                });
                }
                
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        printFactura()
        {
            this.modalFactura = false;
            this.factura_id = '';
        },
        closePrintFacturaModal()
        {
            this.modalFactura = false;
            this.factura_id = '';
        },
        descripcionClick(objectId)
        {

            this.searchItem(objectId, 3);
            let objName = 'autocomplete' + objectId;
            this.$refs[objName][0].inputValue = '';
        },
        async instaSearch(objectId, insta_search)
        {
            if(insta_search.length > 2){
                let searchObject = { 
                    search: insta_search,
                    tabId: objectId
                }
                let obj = this.ventasObject.find(o => o.id === objectId)
                obj.item_search_autocomplete = [];
                await this.$conectar.post('punto-venta/search-items-by-name', searchObject)
                .then(response =>{
                    if(response.data.error == false){
                        obj.item_search_autocomplete = response.data.searchResults;
                    }
                })
                .catch(e => {
                    console.log(e.response);
                })
            }
        },
        moverSubmit(objectId)
        {
            let buttonId = 'procesar_venta_'+objectId;
            document.getElementById(buttonId).focus();
        },
        serializarValor(item) {
			return item.nombre;
		},
        onArticuloSeleccionado(item) {
            let obj = this.ventasObject.find(o => o.id === item.tabId);
            obj.search_descripcion = item.id;

            this.descripcionClick(item.tabId);
		}
    },
}
</script>
<style scoped>

.singleLine {
  white-space: nowrap !important;
  overflow: hidden !important;
}

@media print {
  button {
    display: none;
  }
  #volver{
    display: none;
  }
}
</style>